import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Route } from 'react-router';
import { IconSmile, SheetLayoutContent, SheetLayoutContentWrapper } from '../../../../brenger-shared-ui';
import { r } from '../../../../routes';
import { actions } from '../../ducks';
import { ContactCustomer } from './ContactCustomer';
import { ContactStop } from './ContactStop';
import { useStopContactDetailsPrefill } from '../../hooks/useStopContactDetailsPrefill';
import { useStopContactAddressPrefill } from '../../hooks/useStopContactAddressPrefill';
import { useCustomerPrefill } from '../../hooks/useCustomerPrefill';

export const ContactPage: React.FC = () => {
  const dispatch = useDispatch();
  const { isLoading: isCloading } = useCustomerPrefill();
  const { isLoading: isCpLoading } = useStopContactDetailsPrefill('pickup');
  const { isLoading: iApLoading } = useStopContactAddressPrefill('pickup');
  const { isLoading: iCdLoading } = useStopContactDetailsPrefill('delivery');
  const { isLoading: isAdLoading } = useStopContactAddressPrefill('delivery');

  React.useEffect(() => {
    dispatch(actions.setProgress(6));
  }, []);

  const isLoading = isCloading || isCpLoading || iApLoading || iCdLoading || isAdLoading;

  if (isLoading) {
    return (
      <SheetLayoutContent>
        <IconSmile spinning={true} />
      </SheetLayoutContent>
    );
  }

  return (
    <SheetLayoutContentWrapper>
      <Route exact={true} path={r.generalFlow.contact.index()} component={ContactCustomer} />
      <Route exact={true} path={r.generalFlow.contact.pickup()} component={ContactStop} />
      <Route exact={true} path={r.generalFlow.contact.delivery()} component={ContactStop} />
    </SheetLayoutContentWrapper>
  );
};
